<div class="center-small-container">

  <h1 class="page-title-center">Join a Company</h1>

  <mat-stepper orientation="horizontal" [linear]="true" #stepper>

    <!-- STEP 1 -->
    <mat-step [stepControl]="mcForm" [editable]="false">
      <!-- <ng-template matStepLabel>Find</ng-template> -->

      <p>Find your company</p>

      <form
        class="mb-25"
        [formGroup]="mcForm"
        (ngSubmit)="getCarrierByMc()"
      >
        <mat-form-field appearance="outline" class="full-width mt-15">
          <mat-label>MC</mat-label>

          <input matInput formControlName="mc_number" #mcInput />

          @if (
            mcForm.get('mc_number')?.hasError('required') &&
            (mcForm.get('mc_number')?.touched || mcForm.get('mc_number')?.dirty)
          ) {
            <mat-error>MC is required</mat-error>
          }

          @if (
            mcForm.get('mc_number')?.hasError('pattern') &&
            (mcForm.get('mc_number')?.touched || mcForm.get('mc_number')?.dirty)
          ) {
            <mat-error>Invalid MC number</mat-error>
          }
        </mat-form-field>

        <button
          mat-flat-button
          class="main-button-squared-full-width mt-15"
          type="submit"
          matTooltip="Search"
          [disabled]="mcForm.invalid || loading()"
        >
          @if (!loading()) {
            <span>Search</span>
          } @else {
            <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
          }
        </button>
      </form>
    </mat-step>

    <!-- STEP 2 -->
    <mat-step [editable]="false">
      <!-- <ng-template matStepLabel>Company</ng-template> -->

      @if (carrier) {
        <p>Is this your company?</p>

        <div class="grey-container">
          @if (!carrier.dba_name) {
            {{ carrier.legal_name }}<br />
          } @else {
            {{ carrier.dba_name }}<br />
          }

          {{ carrier.phy_city }}, {{ carrier.phy_state }}<br />
          {{ carrier.docket_prefix }} {{ carrier.docket_number }}<br />

          @if(getCarrierAuthority(carrier)) {
            CARRIER
          }

          @if(getBrokerAuthority(carrier)) {
            BROKER
          }

          @if (!connectionExist()){
            @if (carrier.can_auto_connect) {
              <div class="connection-status mt-15">
                <mat-icon class="auto-connect-icon">check_circle</mat-icon>
                <span>Auto connection available</span>
              </div>
            } @else {
              <div class="connection-status mt-15">
                <mat-icon class="verification-icon">warning</mat-icon>
                <span>Verification required</span>
              </div>
            }
          }

        </div>

        @if (!getCarrierAuthority(carrier) && !getBrokerAuthority(carrier)) {
          <div class="red-container text-center mt-25">
            No active authority. Can't connect.
          </div>
        }

        @if (connectionExist()) {
          <div class="green-container mt-25">
            You already have an active connection with this company.
          </div>
        } @else if (carrier.can_auto_connect) {
          <button
            mat-flat-button
            class="main-button-squared-full-width lightgreen-button mt-15"
            type="button"
            (click)="autoConnect()"
            [disabled]="loading()"
            matTooltip="Connect automatically"
          >
            @if (!loading()) {
              <span>Connect</span>
            } @else {
              <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
            }
          </button>
        } @else {
          <button
            mat-flat-button
            class="main-button-squared-full-width mt-15"
            type="button"
            (click)="stepper.next()"
            [disabled]="(!getCarrierAuthority(carrier) && !getBrokerAuthority(carrier)) || loading()"
            matTooltip="Verify"
          >
            Verify
          </button>
        }
      }
    </mat-step>

    <!-- STEP 3 -->
    <mat-step [editable]="false">
      <!-- <ng-template matStepLabel>Method</ng-template> -->

      @if (carrier) {
        <p>Choose verification method for</p>

        <div class="grey-container">
          @if (!carrier.dba_name) {
            {{ carrier.legal_name }}<br />
          } @else {
            {{ carrier.dba_name }}<br />
          }

          {{ carrier.phy_city }}, {{ carrier.phy_state }}<br />
          {{ carrier.docket_prefix }} {{ carrier.docket_number }}<br />
        </div>

        @if (carrier.email_domain) {
          <div class="grey-container verification-container mt-15">
            <div class="company-email-input">
              <input
                class="plain-email-input"
                placeholder="your email"
                [(ngModel)]="customEmailPrefix"
              />

              <span>&#64;{{ carrier.email_domain }}</span>
            </div>

            <div class="action-container">
              <button
                mat-icon-button
                type="button"
                (click)="createCustomDomainEmailToken()"
                [disabled]="loading()"
              >
                @if (loading()) {
                  <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                } @else {
                  <mat-icon class="primary-color">email</mat-icon>
                }
              </button>
            </div>
          </div>
        }

        @if (carrier.email_address) {
          <div class="grey-container verification-container mt-15">
            <div>
              {{ carrier.email_address | lowercase }}
            </div>

            <div class="action-container">
              <button
                mat-icon-button
                type="button"
                (click)="createToken('email', carrier.email_address)"
                [disabled]="loading()"
              >
                @if (loading()) {
                  <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                } @else {
                  <mat-icon class="primary-color">email</mat-icon>
                }
              </button>
            </div>
          </div>
        }

        @if (carrier.phone) {
          <div class="grey-container verification-container mt-15">
            <div>
              {{ formatPhone(carrier.phone) }}
            </div>

            <div class="action-container">
              <button
                mat-icon-button
                type="button"
                (click)="createToken('sms', carrier.phone)"
                [disabled]="loading()"
              >
                @if (loading()) {
                  <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                } @else {
                  <mat-icon class="primary-color">sms</mat-icon>
                }
              </button>
            </div>
          </div>
        }

        @if (carrier.cell_phone) {
          <div class="grey-container verification-container mt-15">
            <div>
              {{ formatPhone(carrier.cell_phone) }}
            </div>

            <div class="action-container">
              <button
                mat-icon-button
                type="button"
                (click)="createToken('sms', carrier.cell_phone)"
                [disabled]="loading()"
              >
                @if (loading()) {
                  <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
                } @else {
                  <mat-icon class="primary-color">sms</mat-icon>
                }
              </button>
            </div>
          </div>
        }
        
      }
    </mat-step>

    <!-- STEP 4 -->
    <mat-step [stepControl]="tokenForm" [editable]="false">
      <!-- <ng-template matStepLabel>Verify</ng-template> -->

      <p>Verify your code</p>

      <form
        class="mb-25"
        [formGroup]="tokenForm"
        (ngSubmit)="verifyToken()"
      >
        <mat-form-field appearance="outline" class="full-width mt-15">
          <mat-label>Code</mat-label>

          <input matInput formControlName="code" />

          @if (
            tokenForm.get('code')?.hasError('required') &&
            (tokenForm.get('code')?.touched || tokenForm.get('code')?.dirty)
          ) {
            <mat-error>Code is required</mat-error>
          }

          @if (
            tokenForm.get('code')?.hasError('pattern') &&
            (tokenForm.get('code')?.touched || tokenForm.get('code')?.dirty)
          ) {
            <mat-error>Invalid code</mat-error>
          }
        </mat-form-field>

        <div class="yellow-container mt-10">
          @if (resendCodeTimer() > 0) {
            <div class="timer-container">
              Didn't get a code? Resend it in {{ resendCodeTimer() }}
            </div>
          } @else {
            <div class="timer-container">
              Didn't get a code?
              <a
                matTooltip="Resend Verification Code"
                (click)="resendToken()"
              >
                Resend it
              </a>
            </div>
          }
        </div>

        @if (isCustomDomainVerification()) {
          <mat-checkbox
            class="mt-15"
            [(ngModel)]="saveEmail"
            [ngModelOptions]="{ standalone: true }"
          >
            Save this company email
          </mat-checkbox>
        }

        <button
          mat-flat-button
          class="main-button-squared-full-width lightgreen-button mt-15"
          type="submit"
          matTooltip="Verify code"
          [disabled]="tokenForm.invalid || loading()"
        >
          @if (!loading()) {
            <span>Connect</span>
          } @else {
            <mat-spinner diameter="20" strokeWidth="3"></mat-spinner>
          }
        </button>
      </form>
    </mat-step>

  </mat-stepper>

  <div class="bottom-buttons">
    <button
      mat-button
      routerLink="/account/connections"
      matTooltip="My companies"
    >
      My Companies
    </button>

    <button
      mat-button
      (click)="clear()"
      matTooltip="Start over"
    >
      Reset
    </button>
  </div>

</div>